import Vue from 'vue'

Vue.filter('currency', value => {
    let val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
});

Vue.filter('cpfCnpj', value => {
    if(value) {
        if (value.length <= 11) {
            value = value.padStart(11, '0');
            value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');
        } else {
            value = value.padStart(14, '0');
            value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }
    }
    return value;
});

Vue.filter('telefone', value => {
    if(value) {
        if (value.length <= 10) {
            value = value.padStart(10, '0');
            value = value.replace(/(\d{2})(\d{4})(\d{4})/g,'($1) $2-$3');
        } else {
            value = value.padStart(11, '0');
            value = value.replace(/(\d{2})(\d{5})(\d{4})/g,'($1) $2-$3');
        }
    }
    return value;
});